import {
  writable,
} from 'svelte/store';

export const issueSorting = writable(2);
export const departmentSorting = writable(3);
export const departmentShowIssues = writable(false);
export const hoveredIssuePage = writable(undefined);
export const hoveredDepartmentPage = writable(undefined);

function createMouseStore() {
  const {
    subscribe,
    set
  } = writable({
    x: 0,
    y: 0
  });
  document.onmousemove = e => {
    set({
      x: e.pageX,
      y: e.pageY
    })
  };
  return {
    subscribe,
  };
}

export const mouse = createMouseStore();